import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useAssistitiAllergieDataSource(assistitoId:string) {
    const api = new AssistitiApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getAssistitoAllergie({ 
              tenantId: currentTenant.Id, 
              assistitoId: assistitoId 
            });
          },
    
          byKey: (key) => {
            return api.getAssistitoAllergiaById({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                allergiaId: key
            });
          },
    
          insert: (values) => {
            return api.insertAssistitoAllergia({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId, 
                assistitoAllergiaCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateAssistitoAllergia({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                allergiaId: key,
                assistitoAllergiaUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteAssistitoAllergia({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                allergiaId: key
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


